export enum LoadingText {
  Common = 'Loading...',
  PaymentTip = 'Payment is being processed and may take around 10 seconds to complete.',
  AssigningVerifier = 'Assigning a verifier on the blockchain',
  InitiatingRecovery = 'Initiating social recovery...',
  CreateWallet = 'Creating a wallet address on the blockchain',
  CheckingAccount = 'Checking account info on the blockchain',
}
